import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import {
  ICargaFamiliar,
  ICertificadoColectivo,
  ICoberturaPoliza,
  ICreditoPensionado,
  IFormulario,
  IInformacionFTP,
  ILineaNegocio,
  ILiquidacion,
  IPeriodo,
  IPolizaVitalicia,
  IResumenColectivo,
  IResumenPoliza,
  ICaseSalesForce,
  IDocumentTicket,
  IResumenPolizaSalud,
  IDatosContratanteProducto,
  IProducto,
} from 'src/app/shared/Entities/entities';
import { environment } from 'src/environments/environment';
import {
  ICobertura,
  IProductoColectivo,
  IProductoColectivoDetalle,
} from './../Entities/productoColectivo.entities';

import { EMPTY, forkJoin, from, Observable, of, throwError } from 'rxjs';
import { concatMap, map, mergeMap, catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';

import {
  getFullRut,
  getPureRut,
  getLocalStorage,
  setLocalStorage,
} from 'src/app/shared/helpers/helper';

import * as moment from 'moment';
import { ICajaCompensacion } from '../Entities/iCajaCompensacion';
import { ITutorLegal } from '../Entities/ITutorLegal';
import {
  IAporte,
  IDescargaRoutePoliza,
  IGrupoFamiliar,
} from '../Entities/productoIndividual.entities';
import {
  ICartolaCreditos,
  ICreditoPensionadoDetalle,
  ILiquidacionDetalle,
} from '../Entities/productoVitalicio.entities';
import { isBoolean } from 'util';
import { key_user_info, key_local_linea_nego } from '../helpers/constants';
import { CONTEXT } from '@angular/core/src/render3/interfaces/view';
import { ICorreo } from 'src/app/shared/Entities/productoColectivo.entities';
import {
  COVERS_DATA_DUMMY,
  INSUREDS_SERVICE_DATA_DUMMY,
  LINEA_PRODUCTO_DATA_DUMMY,
  RESUMEN_POLIZA_DATA_DUMMY,
} from './product.service.dummy';
import {
  IAPICoversResponse,
  IAPInsuredResponse,
  IAPIParticipantsResponse,
  IParticipant,
} from './product.service.entities';
import * as constants from 'src/app/shared/helpers/constants';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  optionSafe = 'individual';
  private headers: HttpHeaders;
  vidaUrl = `${environment.url.api}/`;
  apiBff = `${environment.url.apiBff}/`;

  @Output() changeOptionSafe: EventEmitter<string> = new EventEmitter();

  lineasNegocio: ILineaNegocio[];

  constructor(private http: HttpClient, private authService: AuthService) {}

  public lineaNegocioAcsel(): Observable<ILineaNegocio[]> {
    const userInfo = getLocalStorage(key_user_info);

    const token = getLocalStorage('token');
    this.headers = new HttpHeaders({
      dominio: 'SitioPrivado',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-IBM-Client-Id': environment.ClientId,
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + token.access_token,
    });

    return this.http
      .get<any>(
        `${
          this.apiBff
        }BffSitioPrivado/ind/Usuarios/Lineasnegocio/ListarLineasNegocio/${getFullRut(
          userInfo.rut
        )}`,
        { headers: this.headers }
      )
      .pipe(
        catchError((err: HttpErrorResponse) => {
          console.error('Error al obtener los datos:', err.message);
          return of([]);
        }),
        map(data => {
          let dataFormat = this.mapData(data);
          setLocalStorage(key_local_linea_nego, dataFormat.LineaProducto);
          this.lineasNegocio = dataFormat.LineaProducto;
          return dataFormat.LineaProducto;
        })
      );
  }

  public mapData(data: any): any {
    return {
      LineaProducto: data.lineaProducto.map(
        (lp: any): ILineaNegocio => ({
          LineaNegocio: lp.lineaNegocio,
          ListaProductos: {
            Producto: lp.listaProductos.producto.map(
              (prod: any): IProducto => ({
                CodigoCliente: prod.codigoCliente,
                Codigo: prod.codigo,
                IdPoliza: prod.idPoliza,
                Nombre: prod.nombre,
                Poliza: prod.poliza,
                IdCliente: prod.idCliente,
              })
            ),
          },
        })
      ),
      HttpCode: data.httpCode,
      HttpMessage: data.httpMessage,
      MoreInformation: data.moreInformation,
      Internal_id: data.internal_id,
    };
  }

  public async getCodigoProductoByNumPoliza(
    numPoliza: number
  ): Promise<string> {
    let lineas = await this.listarLineaNegocio().toPromise();

    let segurosSalud: IProducto[] = this.getProducts(lineas, 'SEGURO SALUD');

    return segurosSalud.find(x => x.IdPoliza === numPoliza).Codigo;
  }

  public listarLineaNegocio(): Observable<ILineaNegocio[]> {
    const lineas = getLocalStorage(key_local_linea_nego);
    if (lineas && lineas.length > 0) {
      return of(lineas);
    }
    const userInfo = getLocalStorage(key_user_info);
    const insuredRut = userInfo.rut.split('-').join('');

    let obsAcsel = this.lineaNegocioAcsel();
    let obsInsis = this.getInsuredCoversInsis(insuredRut);

    return forkJoin(
      obsAcsel.pipe(
        catchError(err => {
          return of([]);
        })
      ),
      obsInsis.pipe(
        map(item => {
          let dataInsis = this.mapFormatLineaNegocio(item);
          let lineas: ILineaNegocio[] = this.mergeLineas([], dataInsis);
          return lineas;
        }),
        catchError(err => {
          return of([]);
        })
      )
    ).pipe(
      map(([dataAcsel, dataInsis]) => {
        let objAcsel: ILineaNegocio[] = [];
        let objInsis: ILineaNegocio[] = [];
        if (dataAcsel) {
          objAcsel = dataAcsel;
        }
        if (objInsis) {
          objInsis = dataInsis;
        }
        let lineas = this.mergeLineas(objAcsel, objInsis);
        setLocalStorage(key_local_linea_nego, lineas);
        this.lineasNegocio = lineas;
        return lineas;
      })
    );
  }

  // Se va a buscar un producto en particular
  getProducts(data: ILineaNegocio[], lineaNegocio) {
    const lista = data.find(d => d.LineaNegocio === lineaNegocio);
    if (!lista) {
      return [];
    }
    return lista.ListaProductos.Producto;
  }

  public getResumen(idPoliza: any[]): Observable<IResumenPoliza> {
    const userInfo = getLocalStorage(key_user_info);
    return from(idPoliza).pipe(
      concatMap(id => {
        return this.http
          .get<IResumenPoliza>(
            `${this.vidaUrl}ind/Polizas/Datos/ObtenerResumen/${id}/${userInfo.rut}`
          )
          .pipe(
            map(res => {
              res.OpcionesMenu.Cartola = this.stringToBoolean(
                res.OpcionesMenu.Cartola
              );
              res.OpcionesMenu.Rentabilidad = this.stringToBoolean(
                res.OpcionesMenu.Rentabilidad
              );
              res.OpcionesMenu.DatosPoliza = this.stringToBoolean(
                res.OpcionesMenu.DatosPoliza
              );
              res.OpcionesMenu.EstadoPago = this.stringToBoolean(
                res.OpcionesMenu.EstadoPago
              );
              res.OpcionesMenu.Retiros = this.stringToBoolean(
                res.OpcionesMenu.Retiros
              );
              res.OpcionesMenu.Traslado = res.OpcionesMenu.Traslado;
              res.OpcionesMenu.ValCuotas = this.stringToBoolean(
                res.OpcionesMenu.ValCuotas
              );
              return res;
            })
          );
      })
    );
  }

  stringToBoolean(value: any): boolean {
    if (isBoolean(value)) {
      return value;
    }

    return value === 'true';
  }

  public getResumenColectivoMap(
    idPoliza: any[]
  ): Observable<IResumenColectivo> {
    const token = getLocalStorage('token');
    const userInfo = getLocalStorage(key_user_info);

    this.headers = new HttpHeaders({
      dominio: 'SitioPrivado',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-IBM-Client-Id': environment.ClientId,
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + token.access_token,
    });

    return from(idPoliza).pipe(
      concatMap(id => {
        return this.http
          .get<any>(
            `${this.apiBff}BffSitioPrivado/col/Polizas/Obtiene/${getFullRut(
              userInfo.rut
            )}/${id}`,
            { headers: this.headers }
          )
          .pipe(
            map(data => {
              if (!data || !data.polizas) {
                return {} as IResumenColectivo;
              }

              //Mappeo para la data que llega del BFF
              const poliza = data.polizas;
              return {
                CodigoPoliza: poliza.codigoPoliza.toString(),
                NumeroPoliza: poliza.numeroPoliza,
                NumeroRenovacion: poliza.numeroRenovacion.toString(),
                FechaInicio: poliza.fechaInicio,
                FechaTermino: poliza.fechaTermino,
                FechaInicioUI: poliza.fechaInicioUI,
                FechaTerminoUI: poliza.fechaTerminoUI,
                Rut: poliza.rut.toString(),
                Dv: poliza.dv,
                RazonSocial: poliza.razonSocial,
                NombreFantasia: poliza.nombreFantasia,
                CodigoAsegurado: poliza.codigoAsegurado.toString(),
                CodigoPlan: poliza.codigoPlan.toString(),
                Plan: poliza.plan,
                Filial: poliza.filial,
                FechaRenovacion: poliza.fechaRenovacion,
                FechaRenovacionUI: poliza.fechaRenovacionUI,
                Coberturas: poliza.coberturas,
                fechaInicioAsegurado: poliza.fechaInicioAsegurado,
                fechaTerminoAsegurado: poliza.fechaTerminoAsegurado,
                fechaOriginalAsegurado: poliza.fechaOriginalAsegurado,
                NumidEmpresaAseguradora: poliza.numidEmpresaAseguradora,
                DvidEmpresaAseguradora: poliza.dvidEmpresaAseguradora,
              } as IResumenColectivo;
            })
          );
      })
    );
  }

  public getResumenColectivo(idPoliza): Observable<IResumenColectivo> {
    const token = getLocalStorage('token');
    const userInfo = getLocalStorage(key_user_info);

    this.headers = new HttpHeaders({
      dominio: 'SitioPrivado',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-IBM-Client-Id': environment.ClientId,
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + token.access_token,
    });

    return this.http
      .get<any>(
        `${this.apiBff}BffSitioPrivado/col/Polizas/Obtiene/${getFullRut(
          userInfo.rut
        )}/${idPoliza}`,
        { headers: this.headers }
      )
      .pipe(
        map(data => {
          if (!data || !data.polizas) {
            return {} as IResumenColectivo;
          }

          //Mappeo para la data que llega del BFF
          const poliza = data.polizas;
          return {
            CodigoPoliza: poliza.codigoPoliza.toString(),
            NumeroPoliza: poliza.numeroPoliza,
            NumeroRenovacion: poliza.numeroRenovacion.toString(),
            FechaInicio: poliza.fechaInicio,
            FechaTermino: poliza.fechaTermino,
            FechaInicioUI: poliza.fechaInicioUI,
            FechaTerminoUI: poliza.fechaTerminoUI,
            Rut: poliza.rut.toString(),
            Dv: poliza.dv,
            RazonSocial: poliza.razonSocial,
            NombreFantasia: poliza.nombreFantasia,
            CodigoAsegurado: poliza.codigoAsegurado.toString(),
            CodigoPlan: poliza.codigoPlan.toString(),
            Plan: poliza.plan,
            Filial: poliza.filial,
            FechaRenovacion: poliza.fechaRenovacion,
            FechaRenovacionUI: poliza.fechaRenovacionUI,
            Coberturas: poliza.coberturas,
            fechaInicioAsegurado: poliza.fechaInicioAsegurado,
            fechaTerminoAsegurado: poliza.fechaTerminoAsegurado,
            fechaOriginalAsegurado: poliza.fechaOriginalAsegurado,
            NumidEmpresaAseguradora: poliza.numidEmpresaAseguradora,
            DvidEmpresaAseguradora: poliza.dvidEmpresaAseguradora,
          } as IResumenColectivo;
        })
      );
  }

  public obtenerCoberturas(idPoliza: any[]): Observable<ICoberturaPoliza> {
    const token = getLocalStorage('token');
    const userInfo = getLocalStorage(key_user_info);

    this.headers = new HttpHeaders({
      dominio: 'SitioPrivado',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-IBM-Client-Id': environment.ClientId,
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + token.access_token,
    });

    return from(idPoliza).pipe(
      concatMap(id => {
        return this.http
          .get<any>(
            `${this.apiBff}BffSitioPrivado/col/Polizas/Lista/${getFullRut(
              userInfo.rut
            )}/${id}`,
            { headers: this.headers }
          )
          .pipe(
            map(data => {
              if (data.polizas.length === 0) {
                return null;
              }
              return data.polizas
                .filter(cobertura => cobertura.polizaId === idPoliza.toString())
                .map(cobertura => ({
                  Poliza: cobertura.polizaId,
                  Plan: cobertura.plan,
                  Empresa: cobertura.empresa,
                  FechaVigencia: cobertura.fechaVigencia,
                  FechaVigenciaUI: cobertura.fechaVigenciaUI,
                  Coberturas: cobertura.coberturas,
                }))[0];
            })
          );
      })
    );
  }

  public obtenerCoberturasFake(): Observable<ICoberturaPoliza> {
    const token = getLocalStorage('token');

    this.headers = new HttpHeaders({
      dominio: 'SitioPrivado',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-IBM-Client-Id': environment.ClientId,
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + token.access_token,
    });

    const idPoliza: any[] = [281872];
    const rut = '141196820';
    return from(idPoliza).pipe(
      concatMap(id => {
        return this.http
          .get<any>(
            `${this.apiBff}BffSitioPrivado/col/Polizas/Lista/${rut}/${id}`,
            { headers: this.headers }
          )
          .pipe(
            map(data => {
              if (data.length === 0) {
                return null;
              }
              return data.polizas
                .filter(cobertura => cobertura.polizaId === idPoliza.toString())
                .map(cobertura => ({
                  Poliza: cobertura.polizaId,
                  Plan: cobertura.plan,
                  Empresa: cobertura.empresa,
                  FechaVigencia: cobertura.fechaVigencia,
                  FechaVigenciaUI: cobertura.fechaVigenciaUI,
                  Coberturas: cobertura.coberturas,
                }))[0];
            })
          );
      })
    );
  }

  //RDP
  /** Servicio que recupera la cobertura de la poliza desde Insis
   * Se debe consultar al servicio "Covers" y buscar por la poliza que nos interesa
   */
  public obtenerCoberturasINSIS(
    policyNumber: string,
    insuredRut: string
  ): Observable<ICoberturaPoliza> {
    return this.getInsuredCoversInsis(insuredRut).pipe(
      map(data => {
        return this.mapCoversToICoberturaPoliza(
          <IAPICoversResponse>data,
          policyNumber
        );
      })
    );
  }

  //RDP
  private mapCoversToICoberturaPoliza(
    data: IAPICoversResponse,
    policyNumber: string
  ): ICoberturaPoliza {
    if (!data) {
      return null;
    }

    const polizas = data.policies.filter(p => p.policyNumber == policyNumber);
    if (polizas.length > 0) {
      const poliza = polizas[0];
      let coberturas: string[] = [];

      poliza.insured.coverages.forEach(element => {
        coberturas.push(element.code);
      });
      const cover = {
        NombreProducto: poliza.product.name,
        Poliza: poliza.policyNumber,
        Coberturas: coberturas,
      };
      return <ICoberturaPoliza>cover;
    } else {
      return null;
    }
  }

  public obtenerResumenVitalicia(): Observable<IPolizaVitalicia[]> {
    const userInfo = getLocalStorage(key_user_info);

    return this.http
      .get<any>(
        `${this.vidaUrl}rv/Polizas/Polizas/ListarResumenPolizas/${userInfo.rut}/${userInfo.rut}`
      )
      .pipe(
        map(data => {
          if (data.length === 0) {
            return null;
          }
          return data.Poliza;
        })
      );
  }

  getDetalleVitalicia(idPoliza, tipo, numPerson): Observable<IPolizaVitalicia> {
    const userInfo = getLocalStorage(key_user_info);

    return this.http.get<IPolizaVitalicia>(
      `${this.vidaUrl}rv/Polizas/Polizas/ObtenerPoliza/${idPoliza}/${getFullRut(
        userInfo.rut
      )}/${tipo}/${numPerson}`
    );
  }

  getColectivoListCertificados(idPoliza): Observable<ICertificadoColectivo[]> {
    const rut = this.authService.getRut();

    return this.http
      .get<any>(
        `${
          this.vidaUrl
        }col/Polizas/Listadocertificados/ListarCoberturasPrestaciones/${idPoliza}/${getPureRut(
          rut
        )}/${getPureRut(rut)}`
      )
      .pipe(
        map(data => {
          const cert = data.Certificado;
          return cert;
        })
      );
  }

  getColectivoListCertificadosFake(
    idPoliza
  ): Observable<ICertificadoColectivo[]> {
    const rut = '14119682-0';

    return this.http
      .get<any>(
        `${
          this.vidaUrl
        }col/Polizas/Listadocertificados/ListarCoberturasPrestaciones/${idPoliza}/${getPureRut(
          rut
        )}/${getPureRut(rut)}`
      )
      .pipe(
        map(data => {
          const cert = data.Certificado;
          return cert;
        })
      );
  }

  /**
   * Descarga el certificado de cobertura en formato base64 para un asegurado en una póliza colectiva.
   *
   * @param {string} idPoliza - ID de la póliza.
   * @param {string} planCodigo - Código del plan.
   * @param {string} productoCodigo - Código del producto.
   * @param {string} aseguradoCodigo - Código del asegurado.
   *
   * @returns {Observable<string>} Un observable con el certificado en base64.
   */
  downloadtColectivoCertificado(
    idPoliza,
    planCodigo,
    productoCodigo,
    aseguradoCodigo
  ): Observable<any> {
    const userInfo = getLocalStorage(key_user_info);
    const token = getLocalStorage('token');

    this.headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-IBM-Client-Id': environment.ClientId,
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + token.access_token,
    });

    const url =
      `${
        this.apiBff
      }BffSitioPrivado/col/Download/policy/${idPoliza}/client/${getFullRut(
        userInfo.rut
      )}/coverageCertificate` +
      `?PlanCode=${planCodigo}` +
      `&ProductCode=${productoCodigo}` +
      `&InsuredCode=${aseguradoCodigo}`;

    return this.http
      .get<any>(url, { headers: this.headers })
      .pipe(
        map((data: any) => {
          const responseData = data.document.base64;
          return responseData;
        }),
        catchError(error => {
          console.error('Error al descargar el certificado:', error);
          return throwError(
            () =>
              new Error(
                'Error al descargar el certificado de colectivo. Intente de nuevo más tarde.'
              )
          );
        })
      );
  }

  downloadColectivoPrestacion(
    idPoliza,
    planCodigo,
    productoCodigo,
    coberturaCodigo
  ): Observable<any> {
    const userInfo = getLocalStorage(key_user_info);

    return this.http.get(
      `${this.vidaUrl}col/Polizas/Descargascertificados/DescargarCertificadoPlanPrestaciones/
      ${idPoliza}/${userInfo.rut}/${planCodigo}/${productoCodigo}/${coberturaCodigo}`,
      { responseType: 'text' }
    );
  }

  downloadColectivoPrestacionFake(
    idPoliza,
    planCodigo,
    productoCodigo,
    coberturaCodigo
  ): Observable<any> {
    const rut = '14119682-0';

    return this.http.get(
      `${this.vidaUrl}col/Polizas/Descargascertificados/DescargarCertificadoPlanPrestaciones/
      ${idPoliza}/${rut}/${planCodigo}/${productoCodigo}/${coberturaCodigo}`,
      { responseType: 'text' }
    );
  }

  getVitaliciaListPeriodoLiquidaciones(
    idPoliza: string,
    tipo: string,
    numPerson: string
  ): Observable<IPeriodo[]> {
    const userInfo = getLocalStorage(key_user_info);
    return this.http
      .get<any>(
        `${
          this.vidaUrl
        }rv/Polizas/Liquidaciones/ListaPeriodos/${idPoliza}/${getFullRut(
          userInfo.rut
        )}/${tipo}/${numPerson}`
      )
      .pipe(
        map(data => {
          const per = data.Periodo;
          return per;
        })
      );
  }

  getVitaliciaListLiquidaciones(
    idPoliza: string,
    tipo: string,
    numPerson: string
  ): Observable<ILiquidacion[]> {
    const userInfo = getLocalStorage(key_user_info);
    return this.http
      .get<any>(
        `${
          this.vidaUrl
        }rv/Polizas/Liquidaciones/ListaLiquidaciones/${idPoliza}/${getFullRut(
          userInfo.rut
        )}/${tipo}/${numPerson}`
      )
      .pipe(
        map(data => {
          const per = data.LiquidacionLista;
          return per;
        })
      );
  }

  downloadVitaliciaLiquidaciones(
    idPoliza,
    tipoSeguro,
    numPersona,
    numeroLiquidacion
  ): Observable<ILiquidacionDetalle> {
    const userInfo = getLocalStorage(key_user_info);

    return this.http.get<any>(
      `${this.vidaUrl}rv/Polizas/Liquidaciones/DescargaLiquidacion/
      ${idPoliza}/${userInfo.rut}/${tipoSeguro}/${numPersona}/${numeroLiquidacion}`
    );
  }

  getColectivoListFormularios(
    usuario: string,
    rol: string
  ): Observable<IFormulario[]> {
    return this.http
      .get<any>(
        `${this.vidaUrl}col/Polizas/Formularios/ListarFormularios/${usuario}/${rol}`
      )
      .pipe(
        map(data => {
          const t = data.Formulario;
          return t;
        })
      );
  }

  getVitaliciaListCreditosPensionados(): Observable<ICreditoPensionado[]> {
    const userInfo = getLocalStorage(key_user_info);
    return this.http
      .get<any>(
        `${this.vidaUrl}rv/Polizas/Creditos/ListarCreditos/${getFullRut(
          userInfo.rut
        )}/${getFullRut(userInfo.rut)}`
      )
      .pipe(
        map(data => {
          if (data) {
            const per = data.Credito;
            return per;
          } else {
            return null;
          }
        })
      );
  }

  downloadVitaliciaCreditosPensionados(
    idPoliza,
    credito: ICreditoPensionado
  ): Observable<ICreditoPensionadoDetalle> {
    const userInfo = getLocalStorage(key_user_info);
    return this.http.get<ICreditoPensionadoDetalle>(
      `${
        this.vidaUrl
      }rv/Polizas/Creditos/DescargaCredito/${idPoliza}/${getFullRut(
        userInfo.rut
      )}/${getFullRut(userInfo.rut)}/${moment(credito.FechaOtorgamiento).format(
        'YYYYMMDD'
      )}/${credito.CodigoTPC}/${userInfo.given_name.split(' ')[0]}/${
        credito.TasaInteres
      }/${credito.Monto}/${credito.NumeroCuotas}`
    );
  }

  generateVitaliciaCartolaCreditosPensionados(
    idPoliza
  ): Observable<ICartolaCreditos> {
    const userInfo = getLocalStorage(key_user_info);
    return this.http.get<ICartolaCreditos>(
      `${
        this.vidaUrl
      }rv/Polizas/Creditos/DescargaCartolaCredito/${idPoliza}/${getFullRut(
        userInfo.rut
      )}/${getFullRut(userInfo.rut)}`
    );
  }

  getColectivoListDetallePlan(
    idPoliza,
    validavigencia
  ): Observable<IProductoColectivo[]> {
    const userInfo = getLocalStorage(key_user_info);
    console.log('userinfo rut: ' + userInfo.rut);
    return this.http
      .get<any>(
        `${
          this.vidaUrl
        }col/Polizas/Productos/ListarProductos/${idPoliza}/${getFullRut(
          userInfo.rut
        )}/${getPureRut(userInfo.rut)}/${validavigencia}`
      )
      .pipe(
        map(res => {
          if (res) {
            const data = res.Producto;
            return data;
          } else {
            return null;
          }
        })
      );
  }

  getColectivoListDetallePlanFake(): Observable<IProductoColectivo[]> {
    //const userInfo = getLocalStorage(key_user_info);
    const idPoliza = 281872;
    const rut = '14119682-0';
    return this.http
      .get<any>(
        `${
          this.vidaUrl
        }col/Polizas/Productos/ListarProductos/${idPoliza}/${getFullRut(
          rut
        )}/${getPureRut(rut)}/1`
      )
      .pipe(
        map(res => {
          if (res) {
            const data = res.Producto;
            return data;
          } else {
            return null;
          }
        })
      );
  }

  public getColectivoAllCoberturas(
    idPoliza: any,
    prod: IProductoColectivo[]
  ): Observable<any> {
    const userInfo = getLocalStorage(key_user_info);
    return from(prod).pipe(
      mergeMap(item => {
        return this.http
          .get<any>(
            `${
              this.vidaUrl
            }col/Polizas/Coberturas/ListarCoberturasProducto/${idPoliza}/${getFullRut(
              userInfo.rut
            )}/${getPureRut(userInfo.rut)}/${item.codigo}/${item.codigoriesgo}`
          )
          .pipe(
            map(res => {
              if (res) {
                const data = {
                  codigo: item.codigo,
                  codigoriesgo: item.codigoriesgo,
                  coberturas: res.Cobertura,
                };
                // const coberturas = res.Cobertura;
                return data;
              } else {
                return null;
              }
            })
          );
      })
    );
  }

  getColectivoListCobertura(
    idPoliza,
    producto,
    riesgo
  ): Observable<ICobertura[]> {
    const userInfo = getLocalStorage(key_user_info);
    return this.http
      .get<any>(
        `${
          this.vidaUrl
        }col/Polizas/Coberturas/ListarCoberturasProducto/${idPoliza}/${getFullRut(
          userInfo.rut
        )}/${getPureRut(userInfo.rut)}/${producto}/${riesgo}`
      )
      .pipe(
        map(res => {
          if (res) {
            const data = res.Cobertura;
            return data;
          } else {
            return null;
          }
        })
      );
  }

  getVitalaicaListCargosFamiliares(idPoliza): Observable<ICargaFamiliar[]> {
    const userInfo = getLocalStorage(key_user_info);
    return this.http
      .get<any>(
        `${
          this.vidaUrl
        }rv/Polizas/Cargasfamiliares/ListarCargasFamiliares/${idPoliza}/${getFullRut(
          userInfo.rut
        )}`
      )
      .pipe(
        map(res => {
          if (res) {
            const data = res.CargaFamiliar;
            return data;
          } else {
            return null;
          }
        })
      );
  }

  getCajaCompensacion(
    idPoliza: string,
    numPersona: string
  ): Observable<ICajaCompensacion> {
    const userInfo = getLocalStorage(key_user_info);

    return this.http
      .get<any>(
        `${this.vidaUrl}rv/Polizas/Cajacompensacion/ObtenerCajaCompensacion/${idPoliza}/${numPersona}/${userInfo.rut}`
      )
      .pipe(
        map(data => {
          return data;
        })
      );
  }

  getTutorLegal(
    idPoliza: string,
    tipo: string,
    numPersona: string
  ): Observable<ITutorLegal> {
    const userInfo = getLocalStorage(key_user_info);

    return this.http
      .get<any>(
        `${this.vidaUrl}rv/Polizas/Tutorlegal/ObtenerTutorLegal/${getPureRut(
          userInfo.rut
        )}/${idPoliza}/${numPersona}/${tipo}`
      )
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  getVitaliciaListPeriodoCertificados(): Observable<string[]> {
    const userInfo = getLocalStorage(key_user_info);
    return this.http.get<any>(
      `${this.vidaUrl}rv/Polizas/Certificados/ListarPeriodos/${getFullRut(
        userInfo.rut
      )}/SucursalVirtualFTP`
    );
  }

  getDatosDescargaPoliza(idPoliza): Observable<IDescargaRoutePoliza> {
    const userInfo = getLocalStorage(key_user_info);
    return this.http.get<IDescargaRoutePoliza>(
      `${
        this.vidaUrl
      }ind/Polizas/Documentos/ObtenerDatosDocumentoPoliza/${idPoliza}/${getFullRut(
        userInfo.rut
      )}`
    );
  }

  getAportes(idPoliza): Observable<IAporte[]> {
    const userInfo = getLocalStorage(key_user_info);
    return this.http
      .get<any>(
        `${
          this.vidaUrl
        }ind/Polizas/Aportes/ListarAportes/${idPoliza}/${getFullRut(
          userInfo.rut
        )}`
      )
      .pipe(
        map(data => {
          if (!data) {
            return null;
          }
          const aportes = data.Aportes as IAporte[];
          return aportes.sort((a, b) => {
            return moment(a.Periodo, 'YYYY-MM-DD').isBefore(
              moment(b.Periodo, 'YYYY-MM-DD')
            )
              ? 1
              : -1;
          });
        })
      );
  }

  getGrupoFamiliar(idPoliza): Observable<IGrupoFamiliar[]> {
    const userInfo = getLocalStorage(key_user_info);
    const pureRut = getPureRut(userInfo.rut);
    return this.http.get<IGrupoFamiliar[]>(
      `${this.vidaUrl}col/Polizas/Asegurados/ListarCargas/${idPoliza}/${pureRut}/${pureRut}`
    );
  }

  ///Este metodo ya no se usa
  postCasoSalesForceAmpliado(
    nombreContratante,
    rutContratante,
    emailContratante,
    telDeposito,
    subject,
    description,
    detalleRescate,
    tipoMoneda,
    pagoRescate,
    montoUF,
    poliza,
    detalleSolicitud,
    fechaCreacion,
    tipoSolicitante: string,
    casoCategoria: string,
    emailSolicitante: string
  ): Observable<any> {
    const srvTimeout = environment.service.salesForce.timeOut;
    const ibmClientId = environment.service.salesForce.clientId;
    const endpointURL = environment.service.salesForce.endpoint_url;
    const organizacion = environment.service.salesForce.organizacion;
    const body = {
      SuppliedName: nombreContratante,
      SuppliedEmail: emailContratante,
      SuppliedPhone: '+56' + telDeposito,
      RecordType: {
        Name: 'Solicitudes',
      },
      Status: 'Nuevo',
      Origin: 'WEB',
      Subject: subject,
      Priority: 'Baja',
      Description: description,
      CurrencyIsoCode: 'CLF',
      Atencion_Presencial__c: true,
      Canal__c: 'WEB',
      Cerrado_por_Usuario_de_Autoservicio__c: false,
      Correo_electronico_Solicitante__c:
        tipoSolicitante === 'Contratante' ? '' : emailSolicitante,
      Detalle_Solicitud__c: detalleSolicitud,
      Negocio__c: 'Seguros Individuales',
      Nombre_Solicitante__c:
        tipoSolicitante === 'Contratante' ? '' : nombreContratante,
      RUT_Solicitante__c:
        tipoSolicitante === 'Contratante' ? '' : rutContratante,
      Solicita_envio_a_otra_direccion__c: false,
      Telefono_Solicitante__c:
        tipoSolicitante === 'Contratante' ? '' : '+56' + telDeposito,
      Tipo_de_Solicitante__c: tipoSolicitante,
      Visible_en_el_Portal_de_Autoservicio__c: false,
      Campa_a_Mailing__c: false,
      Llamadas_Out__c: false,
      Cliente_Compania__c: true,
      Carta_Cliente__c: false,
      CASO_Categoria__c: casoCategoria,
      Detalle_de_Rescate__c: detalleRescate,
      Tipo_de_Moneda__c: tipoMoneda,
      Pago_de_Rescate__c: pagoRescate,
      Prima_Total_Final__c: montoUF,
      CASO_N_Poliza__r: {
        N_Poliza__c: Number(poliza),
      },
      CASO_Poliza_Asoc__c: Number(poliza),
      Correo_electronico_alternativo__c: emailSolicitante,
      Telefono_de_Contacto__c: '+56' + telDeposito,
      Tipo_de_Requerimiento__c: 'Solicitudes',
      // CreatedDate: fechaCreacion
    };

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-ibm-client-id': ibmClientId,
        Organizacion: organizacion,
        timeout: srvTimeout.toString(),
      }),
    };
    const serviceURL = this.vidaUrl + endpointURL;
    return this.http.post(serviceURL, body, httpOptions);
  }

  /*
  getCasoSalesForce(idCase: string): Observable<ICaseSalesForce> {
    const userInfo = getLocalStorage(key_user_info);

    const srvTimeout = environment.service.salesForce.timeOut;
    const ibmClientId = environment.service.salesForce.clientId;
    const organizacion = environment.service.salesForce.organizacion;

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-ibm-client-id': ibmClientId,
        Organizacion: organizacion,
        timeout: srvTimeout.toString(),
      }),
    };

    const serviceURL = this.vidaUrl + 'com/Servicio/CRM/Case/' + idCase;
    return this.http.get<any>(serviceURL, httpOptions).pipe(
      map(data => {
        return data;
      })
    );
  }
  */

  postSendMail(
    numSolicitud,
    idTypeDoc,
    nombreContratante,
    fechaHoy,
    tipo,
    poliza: string
  ): Observable<any> {
    const body = {
      RequestCode: numSolicitud,
      ContractorName: nombreContratante,
      Date: fechaHoy,
      Type: tipo,
      Poliza: poliza,
    };
    console.log('nro es ' + body);
    console.log(body);

    const token = getLocalStorage('token');
    const headers: HttpHeaders = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-IBM-Client-Id': environment.ClientId,
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + token.access_token,
    });

    const serviceURL =
      environment.url.apiBff + '/BffSitioPrivado/SendMail/Type/' + idTypeDoc;
    return this.http.post<any>(serviceURL, body, { headers: headers });
  }

  postSendMailBeneficiario(
    targetMail,
    fechaHoy,
    idTypeDoc,
    idPoliza: number,
    bodyCorreo: ICorreo
  ): Observable<any> {
    const body = {
      TargetMail: targetMail,
      Date: fechaHoy,
      Poliza: idPoliza,
      ObjetoCorreo: bodyCorreo,
    };

    console.log('postSendMailBeneficiario body ');
    console.log(body);

    const token = getLocalStorage('token');
    const headers: HttpHeaders = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-IBM-Client-Id': environment.ClientId,
      'Access-Control-Allow-Origin': '*',
      Authorization: 'Bearer ' + token.access_token,
    });

    const serviceURL =
      environment.url.apiBff + '/BffSitioPrivado/SendMail/Type/' + idTypeDoc;
    return this.http.post<any>(serviceURL, body, { headers: headers });
  }

  /*
  postDocumentosAdjuntosSalesForce(
    documentsUrl,
    idCase: string
  ): Observable<any> {
    const ibmClientId = environment.service.salesForce.clientId;
    const endpointURL = 'com/Servicio/CRM/Case';
    const organizacion = environment.service.salesForce.organizacion;

    const bodyDocument = [];
    for (const doc of documentsUrl.adjuntos) {
      const idticket = doc.idTicket;
      const nombreDoc = doc.nombreDocumento;
      const dataDoc = {
        Id_Ticket__c: idticket,
        Id_Retorno__c: null,
        Nombre_Documento__c: nombreDoc,
        UrlDoc__c: null,
      };
      bodyDocument.push(dataDoc);
    }

    const body = {
      Rut: documentsUrl.rut,
      Adjuntos: bodyDocument,
    };

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-ibm-client-id': ibmClientId,
        Organizacion: organizacion,
      }),
    };
    const serviceURL = this.vidaUrl + endpointURL + '/' + idCase + '/Adjuntos';
    return this.http.post(serviceURL, body, httpOptions);
  }
  */

  getDocumentByTicket(idTicket: number): Observable<IDocumentTicket> {
    const endpointURL = environment.service.file.endpoint_url;
    const ibmClientId = environment.service.file.clientId;

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-ibm-client-id': ibmClientId,
      }),
    };

    return this.http
      .get<any>(
        `${this.vidaUrl}${endpointURL}/ByTicket?Empresa=VIDA%20SECURITY&Archivador=Seguros%20Individuales&IdTicket=${idTicket}`,
        httpOptions
      )
      .pipe(
        map(data => {
          return data;
        })
      );
  }

  postMailService(emailDeposito, subjectIn, html): Observable<any> {
    const srvTimeout = environment.service.mail.timeOut;
    const ibmClientId = environment.service.mail.clientId;
    const endpointURL = environment.service.mail.endpoint_url;
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-ibm-client-id': ibmClientId,
        timeout: srvTimeout.toString(),
      }),
    };

    const body = {
      from: environment.correoVidaSecurity,
      to: emailDeposito,
      cc: '',
      cco: '',
      subject: subjectIn,
      isHtml: true,
      Code: '',
      GroupCode: 'Endosos',
      body: html,
    };

    const serviceURL = this.vidaUrl + endpointURL;
    return this.http.post<any>(serviceURL, body, httpOptions);
  }

  postDocumento(
    idPoliza,
    nombreContratante,
    rutAsegurado,
    tipoDocumento,
    indx
  ): Observable<any> {
    const srvTimeout = environment.service.file.timeOut;
    const ibmClientId = environment.service.file.clientId;
    const endpointURL = environment.service.file.endpoint_url;
    const httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-ibm-client-id': ibmClientId,
        timeout: srvTimeout.toString(),
      }),
    };

    const body = {
      Empresa: 'VIDA SECURITY',
      Archivador: 'Seguros Individuales',
      Documentos: [
        {
          TipoDocumento: tipoDocumento,
          Content: indx.base64,
          Extension: indx.extension,
          Index: [
            {
              Label: 'NOMBRECONTRATANTE',
              Value: nombreContratante,
            },
            {
              Label: 'POLIZA',
              Value: idPoliza,
            },
            {
              Label: 'RUTASEGURADO',
              Value: rutAsegurado,
            },
            {
              Label: 'SINIESTRO',
              Value: '',
            },
          ],
        },
      ],
    };

    const serviceURL = this.vidaUrl + endpointURL;
    return this.http.post<any>(serviceURL, body, httpOptions);
  }

  public getInsuredInfo(RutDv: string, IdPoliza: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'x-api-version': 'V2',
        'X-IBM-Client-Id': environment.ClientIdCorredores,
        dominio: 'Corredores',
      }),
    };

    return this.http.get<any>(
      environment.url.api +
        '/col/Claims/Insured/' +
        RutDv +
        `?PolicyNumber=${IdPoliza}`,
      httpOptions
    );
  }

  public getPlanInfo(PolicyNumber: string, Rut: string): Observable<any> {
    return this.http.get<any>(
      environment.url.api +
        '/col/PolicyServicing/Policy/' +
        PolicyNumber +
        `/insured/${Rut}`
    );
  }

  public getPlanData(PolicyCode: string, PlanCode: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'x-api-version': 'V2',
      }),
    };
    return this.http.get<any>(
      environment.url.api +
        '/col/PolicyServicing/Policy/' +
        PolicyCode +
        `/plan/${PlanCode}`,
      httpOptions
    );
  }

  //------------------------------------------------------
  //
  //  FUNCIONES AGREGADAS PARA SALUD DIGITAL
  //
  // -----------------------------------------------------

  //RDP : PolicyService V2 - Inis */
  /**
   *
   * @param PolicyNumber Get Policy information from Insis
   * @returns
   */
  public getPolicyInfo(PolicyNumber): Observable<any> {
    //if(constants.SALUD_IND_USE_DUMMY == true){
    //  return of(COVERS_DATA_DUMMY);
    //}
    const httpOptions = {
      headers: new HttpHeaders({
        dominio: 'SitioPrivado',
        'x-api-version': '2',
      }),
    };
    const serviceURL =
      environment.url.api + '/' + 'ind/PolicyServicing/Policy/' + PolicyNumber;
    return this.http.get<any>(serviceURL, httpOptions);
  }

  //RDP
  public getResumenSalud(policyNumber): Observable<IResumenPolizaSalud> {
    return this.getPolicyInfo(policyNumber).pipe(
      map(data => {
        return this.mapPolicyServiceToIResumenPoliza(data);
      })
    );
  }

  //RDP
  public mapPolicyServiceToIResumenPoliza(data: any): IResumenPolizaSalud {
    let resumen: IResumenPolizaSalud = {
      NumeroPoliza: data.policy.policyNumber,
      NumeroPropuesta: data.policy.proposalNumber,
      IdentificadorPoliza: data.policy.policyId,
      CodigoEstadoPoliza: data.policy.state.code,
      EstadoPoliza: data.policy.state.name,
      CodigoRamo: data.policy.product.type,
      NombreProducto: data.policy.product.name,
      Periodicidad: data.policy.periodicity,
      ViaPago: data.policy.paymentWay.name,
      InicioVigencia: data.policy.beginDate,
      TerminoVigencia: data.policy.dueDate,
    };

    return <IResumenPolizaSalud>resumen;
  }

  // RDP
  /** Se debe hacer un merge de las Lineas de negocios de individuales.
   Se recorren todos los tipos
  y mezclar cada tipo existente en cada lista y construir una sola lista
  **/
  mergeLineas(
    dataAcsel: ILineaNegocio[],
    dataInsis: ILineaNegocio[]
  ): ILineaNegocio[] {
    let keys = [];
    // Se construye una lista con todos los nombres
    dataAcsel.forEach(value => {
      keys.push(value.LineaNegocio);
    });
    dataInsis.forEach(value => {
      keys.push(value.LineaNegocio);
    });
    keys = this.removeDuplicates(keys);

    let nuevo = { LineaProducto: [] };

    keys.forEach(key => {
      let lista = this.getProducts(dataAcsel, key);
      let listaINSIS = this.getProducts(dataInsis, key);
      let listaunificada = lista.concat(listaINSIS);

      // Para cada llave se concatena la lista
      const x = {
        LineaNegocio: key,
        ListaProductos: {
          Producto: listaunificada,
        },
      };
      nuevo.LineaProducto.push(x);
    });
    return nuevo.LineaProducto;
  }

  //RDP
  removeDuplicates(array: string[]): string[] {
    return array.filter((value, index, self) => self.indexOf(value) === index);
  }

  /** RDP: Se recuperan los participants desde INSIS */
  public getParticipantsINSIS(
    policyNumber: any
  ): Observable<IAPIParticipantsResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        dominio: 'SitioPrivado',
      }),
    };
    const serviceURL =
      environment.url.api +
      '/' +
      'ind/policyServicing/' +
      policyNumber +
      '/participants';
    return this.http.get<IAPIParticipantsResponse>(serviceURL, httpOptions);
  }

  /** RDP: Se recuperan los productos desde INSIS */
  public getInsuredCoversInsis(insuredRut): Observable<any> {
    return of([]);
  }

  /** RDP: Map para homologar la estructura de las lineas de negocio */
  public mapFormatLineaNegocio(data: IAPICoversResponse) {
    var lineaProducto;
    let producto = [];

    data.policies.forEach(element => {
      if (constants.SALUD_INDIVIDUAL.includes(element.product.type)) {
        producto.push({
          CodigoCliente: element.insured.rut,
          Codigo: element.product.type,
          IdPoliza: element.policyNumber,
          Nombre: element.product.name,
          Poliza: element.policyNumber,
          IdCliente: element.status,
        });
      }
    });

    lineaProducto = [
      {
        LineaNegocio: constants.LINEA_NEGOCIO.SALUD_INDIVIDUAL,
        ListaProductos: {
          Producto: producto,
        },
      },
    ];

    return lineaProducto;
  }

  /**
   * RDP:
   * Llama al servicio de recuperacio de participantes y devuelve el contratante
   * @param policyNumber
   */
  getContratanteInsis(policyNumber): Observable<IDatosContratanteProducto> {
    return this.getParticipantsINSIS(policyNumber).pipe(
      map(data => {
        let contratante: IDatosContratanteProducto = <
          IDatosContratanteProducto
        >{};
        const participants = data.participants.filter(
          el => el.role === 'PHOLDER'
        );
        let holder = participants[0];

        let mail = holder.contact.find(el => el.type === 'Email');
        let telefonoParticular = holder.contact.find(
          el => el.type === 'Mobile'
        );
        let telefonoComercial = holder.contact.find(el => el.type === 'Office');
        let direccionParticular = holder.address.find(el => el.type === 'Home');
        let direccionComercial = holder.address.find(
          el => el.type === 'Business'
        );
        let direccionCorrespondencia = holder.address.find(
          el => el.type === 'Correspondence'
        );

        contratante.Rut = holder.rut;
        contratante.Nombre = holder.names;
        contratante.Correo = mail ? mail.detail : null;
        contratante.Celular = telefonoParticular
          ? telefonoParticular.detail
          : null;
        contratante.Direccion = direccionParticular
          ? direccionParticular.address
          : null;
        contratante.Comuna = direccionParticular
          ? direccionParticular.township.name
          : null;
        contratante.Ciudad = direccionParticular
          ? direccionParticular.province.name
          : null;
        contratante.Region = direccionParticular
          ? direccionParticular.region.name
          : null;
        contratante.TelefonoComercial = telefonoComercial
          ? telefonoComercial.detail
          : null;
        contratante.DireccionComercial = direccionComercial
          ? direccionComercial.address
          : null;
        contratante.comunaComerc = direccionComercial
          ? direccionComercial.township.name
          : null;
        contratante.ciudadComerc = direccionComercial
          ? direccionComercial.province.name
          : null;
        contratante.regionComerc = direccionComercial
          ? direccionComercial.region.name
          : null;
        contratante.DireccionCorres = direccionCorrespondencia
          ? direccionCorrespondencia.address
          : null;
        contratante.comunaComerc = direccionCorrespondencia
          ? direccionCorrespondencia.township.name
          : null;
        contratante.ciudadCorres = direccionCorrespondencia
          ? direccionCorrespondencia.province.name
          : null;
        contratante.regionCorres = direccionCorrespondencia
          ? direccionCorrespondencia.region.name
          : null;

        return contratante;
      })
    );
  }

  public getIndInsuredINSIS(policyNumber: any): Observable<IAPInsuredResponse> {
    const httpOptions = {
      headers: new HttpHeaders({
        dominio: 'SitioPrivado',
        'x-api-version': '2',
      }),
    };
    const serviceURL =
      environment.url.api +
      '/' +
      'ind/policyServicing/' +
      policyNumber +
      '/insureds';
    return this.http.get<IAPInsuredResponse>(serviceURL, httpOptions);
  }
}
